import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const [showAll, setShowAll] = useState(false);
  const displayedCategories = showAll ? categories : categories.slice(0, 6);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-14">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Curated Product
            <br />
            <span className="font-light text-foreground-700">Categories</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-600 font-light max-w-md">
            Navigate verified spreadsheet collections. Each category links to organized product listings with detailed QC data.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {displayedCategories.map((cat, idx) => {
            const offsetClass = idx % 3 === 1 ? 'lg:translate-y-8' : idx % 3 === 2 ? 'lg:translate-y-4' : '';

            return (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className={`group block bg-background-50 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] ${offsetClass}`}
              >
                <div className="relative h-52 md:h-60 overflow-hidden">
                  <img
                    src={cat.image}
                    alt={`${cat.name} product category`}
                    title={`${cat.name} - Hipobuy Spreadsheet Category`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 via-transparent to-transparent"></div>
                </div>

                <div className="px-5 py-5">
                  <div className="flex items-center gap-2.5 mb-2">
                    <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className={`${cat.icon} text-base`}></i>
                    </span>
                    <h3 className="font-heading text-lg font-semibold text-foreground-950">{cat.name}</h3>
                  </div>
                  <p className="text-xs text-foreground-500 mb-4">{cat.count}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-500 truncate max-w-[70%]">{cat.desc}</span>
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50 group-hover:bg-primary-600 transition-colors duration-200 flex-shrink-0">
                      <i className="ri-arrow-right-up-line text-sm"></i>
                    </span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>

        {categories.length > 6 && (
          <div className="mt-10 text-center">
            <button
              onClick={() => setShowAll(!showAll)}
              className="px-6 py-2.5 rounded-full border-2 border-primary-500 text-primary-700 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-50 transition-colors duration-200"
            >
              {showAll ? 'Show Less Categories' : 'View All 14 Categories'}
              {showAll ? (
                <i className="ri-arrow-up-s-line ml-1.5"></i>
              ) : (
                <i className="ri-arrow-down-s-line ml-1.5"></i>
              )}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}